import { Instagram, Youtube, Facebook, ExternalLink, PlayCircle } from "lucide-react";
import { SOCIALS, VIDEOS, YT_CHANNEL } from "@/lib/constants";

const iconFor = (p) => ({ instagram: Instagram, youtube: Youtube, facebook: Facebook }[p] || ExternalLink);

export default function MediaSocial() {
  return (
    <section data-testid="multimedia-social-section" className="max-w-7xl mx-auto px-4 my-14 grid lg:grid-cols-2 gap-8">
      {/* Social */}
      <div>
        <div className="flex items-center gap-2 mb-4 border-b-2 border-legend-red pb-2">
          <h2 className="font-display font-black uppercase text-2xl">Canali Social Ufficiali</h2>
        </div>
        <div className="space-y-3">
          {SOCIALS.map((s, i) => {
            const Icon = iconFor(s.platform);
            return (
              <a
                key={i}
                href={s.url}
                target="_blank"
                rel="noreferrer"
                data-testid={`social-link-${i}`}
                className={`flex items-center gap-4 p-4 rounded-sm border border-slate-200 dark:border-slate-800 bg-white dark:bg-legend-paper hover:border-legend-red hover:shadow-md transition-all group ${s.soon ? "opacity-60" : ""}`}
              >
                <span className="grid place-items-center w-11 h-11 rounded-sm bg-legend-ink text-white group-hover:bg-legend-red transition-colors">
                  <Icon size={20} />
                </span>
                <div className="flex-1">
                  <p className="font-display font-bold uppercase leading-none">{s.name}</p>
                  <p className="text-xs text-slate-500 font-mono">{s.handle}</p>
                </div>
                {s.soon ? <span className="text-[10px] uppercase font-mono text-legend-yellow bg-legend-ink px-2 py-1 rounded-sm">In arrivo</span> : <ExternalLink size={16} className="text-slate-400 group-hover:text-legend-red" />}
              </a>
            );
          })}
        </div>
      </div>

      {/* Videos */}
      <div>
        <div className="flex items-center justify-between mb-4 border-b-2 border-legend-red pb-2">
          <h2 className="font-display font-black uppercase text-2xl">Video & Media</h2>
          <a href={YT_CHANNEL} target="_blank" rel="noreferrer" className="text-xs font-mono uppercase text-legend-red inline-flex items-center gap-1">
            Canale YouTube <ExternalLink size={12} />
          </a>
        </div>
        <div className="space-y-4">
          {VIDEOS.map((v) => (
            <div key={v.id} data-testid={`youtube-video-${v.id}`} className="rounded-sm overflow-hidden border border-slate-200 dark:border-slate-800 bg-black">
              <div className="relative w-full" style={{ paddingTop: "56.25%" }}>
                <iframe
                  className="absolute inset-0 w-full h-full"
                  src={`https://www.youtube-nocookie.com/embed/${v.id}`}
                  title={v.title}
                  loading="lazy"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                />
              </div>
              <div className="flex items-center gap-2 px-3 py-2 bg-legend-paper text-white text-sm">
                <PlayCircle size={16} className="text-legend-red" /> {v.title}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
